import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5150c47f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "onClick"]
const _hoisted_2 = {
  key: 1,
  class: "imagen",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}

import { ref, onBeforeMount, onBeforeUnmount } from "vue";

import { getSamplingPointImagesLabel, getImage } from "@/service/image.service";
import { ImageLabelData } from "@/types/Image.type.ts";
import { ImageLabel, FilterImagesLabel } from "@/types/imageLabel.type.ts";
import { ArrowDown } from "@element-plus/icons-vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import ImageLabelForm from "@/components/processTracking/imageLabel/imageLabelForm.component";
import cloneDeep from "lodash/cloneDeep";
import { Pagination } from "@/types/pagination.type";
import { useRoute } from "vue-router";
import { getImageLabelHistoryByClassification } from "@/service/imageLabelHistory.service.ts";
import { applyFilterBBDD } from "@/utils/imageLabel.util.ts";
import ImagesLabelGallery from "@/components/processTracking/imageLabel/imageLabelGallery.component";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";

type FormFilter = {
  samplingPoint: SamplingPoint;
  fromDateTime: Date;
  toDateTime: Date;
  numberImageLabel: number;
  type: string;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    filters: null,
    imgFilter: null,
    images: null,
    imagesrc: null,
    copy: null,
    labels: null,
    filterImages: null
  },
  emits: ["updateImages", "updateTotal"],
  setup(__props: any, { expose, emit }: { emit: ({
  (
    e: "updateImages",
    value: ImageLabelData[],
    src: Record<string, string>,
    copy: ImageLabelData[],
    labels: ImageLabelData[]
  ): void;
  (e: "updateTotal", total: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  filters: FormFilter;
  imgFilter: string;
  images?: Array<ImageLabelData>;
  imagesrc?: Record<string, string>;
  copy?: Array<ImageLabelData>;
  labels?: Array<ImageLabelData>;
  filterImages?: FilterImagesLabel;
}

const formCmp = ref<InstanceType<typeof ImagesLabelGallery> | null>(null);
const route = useRoute();
const correctRoute = route.path === "/process-tracking/samplingpoints/FQConfig";
const LIMIT = 15;





const currentImage = ref<ImageLabelData>({});
const selectedImage = ref<ImageLabelData>({});
const copyCurrentImage = ref<ImageLabelData>({});
const allImages = ref<ImageLabelData[]>([]);
const copyAllImages = ref<ImageLabelData[]>([]);

const cameraConfigs = ref<any[]>([]);

const src = ref<Record<string, string>>({});

const labelArray = ref<ImageLabel[]>([]);
const current = ref<number>(0);

// Identidicadores de la imágenes
const selectedImages = ref<Set<number>>(new Set());
const lastSelectedIndex = ref<number | null>(null);

const loading = ref(false);
const finished = ref(false);
const lastDateTime = ref<Date | null>(null);
// Abrir un pop-up
const isOpenImage = ref<boolean>(false);
const galleryKey = ref<number>(0);
const totalImg = ref<number>(0);

/**
 * Selección de la imagen
 * @param img
 * @param index
 * @param event
 */
const toggleSelection = (img: ImageLabelData, index: number, event: MouseEvent) => {
  const id = img.id;

  if (!img) return;

  updateCurrentImage(img);

  // --- Ctrl / Cmd + click ---
  if (event.ctrlKey || event.metaKey) {
    if (selectedImages.value.has(id)) {
      selectedImages.value.delete(id);
    } else {
      selectedImages.value.add(id);
    }
    lastSelectedIndex.value = index;
  }
  // --- Shift + click (rango) ---
  else if (event.shiftKey && lastSelectedIndex.value !== null) {
    const start = Math.min(lastSelectedIndex.value, index);
    const end = Math.max(lastSelectedIndex.value, index);

    for (let i = start; i <= end; i++) {
      selectedImages.value.add(allImages.value[i].id);
    }
  }
  // --- Click simple ---
  else {
    selectedImages.value.clear();
    selectedImages.value.add(id);
    lastSelectedIndex.value = index;
  }
};

/**
 * Cargar las miniaturas y recuperar el etiquetado
 * @param images
 */
const loadImages = (images: ImageLabelData[]) => {
  images.forEach(async (image) => {
    if (image?.fileName && !src.value[image.fileName]) {
      getImage(image.fileName, true).then((res) => {
        if (image?.fileName) {
          src.value[image.fileName] = res;
        }
        if (image.imageLabel) {
          image.imageLabel.image = { id: image.id };
          image.imageLabel.statusLabel = "warning";
          if (route.query.type === "edit") {
            labelArray.value.push(image.imageLabel);
          }
        }
      });
    }
  });
};

/**
 * Cargar más imágenes
 * @param limit
 */
const uploadMore = async () => {
  if (props.images && props.images.length > 0) {
    allImages.value = props.images;
    src.value = props.imagesrc;
    copyAllImages.value = props.copy;
    lastDateTime.value = allImages.value[allImages.value.length - 1].dateTime.toString();
    current.value++;
    labelArray.value = props.labels;
  }

  if (loading.value || finished.value) return;
  const fromDateTime = lastDateTime.value || props.filters.fromDateTime;

  let imageLabel: Pagination<ImageLabelData> = {};

  if (
    (allImages.value.length > 0 &&
      new Date(allImages.value[allImages.value.length - 1].dateTime) <
        new Date(props.filters.toDateTime)) ||
    (allImages.value.length === 0 &&
      new Date(props.filters.fromDateTime) < new Date(props.filters.toDateTime))
  ) {
    if (route.query.classification) {
      loading.value = true;
      const filters = applyFilterBBDD(props.filterImages, "imageLabelHistory");
      imageLabel = await getImageLabelHistoryByClassification(
        route.query.classification,
        props.filters.samplingPoint.id,
        current.value,
        LIMIT,
        fromDateTime,
        props.filters.toDateTime,
        filters.fields ? filters : undefined
      );
      current.value++;
    } else {
      loading.value = true;
      const filters = applyFilterBBDD(props.filterImages, "imageLabel");
      imageLabel = await getSamplingPointImagesLabel(
        `${props.filters.samplingPoint.id}`,
        current.value,
        LIMIT,
        fromDateTime,
        props.filters.toDateTime,
        undefined,
        props.filters.cameras,
        filters.fields ? filters : undefined
      );
      current.value++;
    }
  }
  const rawData = imageLabel.data || [];
  const filteredConfigs = cameraConfigs.value.filter((config) => config.modele);
  const hasAnyDay = rawData.some((img) => img.dayOrNight === "DAY");

  const data = rawData.filter((img) => {
    if (hasAnyDay && !img.dayOrNight) return false;

    if (!img.dayOrNight || filteredConfigs.length < 2) return true;

    const imgCamera = String(img.camera || "")
      .trim()
      .toLowerCase();
    const imgDayOrNight = String(img.dayOrNight || "")
      .trim()
      .toLowerCase();

    const currentConfig = cameraConfigs.value?.find((cam) => {
      const configCameraCode = String(cam?.camera?.code || "")
        .trim()
        .toLowerCase();

      return imgCamera === configCameraCode;
    });

    if (currentConfig) {
      const configTime = String(currentConfig.imageProcessingTime || "")
        .trim()
        .toLowerCase();

      return imgDayOrNight === configTime;
    }

    return true;
  });
  //---

  if (data && data.length > 0) {
    allImages.value.push(...data);
    // Clonar valores para mantener los valores originales
    copyAllImages.value.push(...cloneDeep(data));

    loadImages(data);
    //  cursor avanza a la fecha de la última imagen recibida
    lastDateTime.value = data[data.length - 1].dateTime.toString();
  } else {
    finished.value = true; // no hay más imágenes
  }

  loading.value = false;

  const isFirstQuery = fromDateTime === props.filters.fromDateTime;

  if (isFirstQuery) {
    emit("updateTotal", imageLabel.totalRows);
  }
};

/**
 * Obtener las imágenes que se van a mostrar
 */

const updateCurrentImage = (img: ImageLabelData | undefined) => {
  if (!img) return;

  const index = allImages.value.findIndex((i) => i.id === img.id);
  if (index === -1) return;

  currentImage.value = allImages.value[index];
  console.log("currentImage", currentImage.value);
  copyCurrentImage.value = cloneDeep(copyAllImages.value[index]);
  console.log("copyCurrentImage", copyCurrentImage.value);
};

/**
 * Obtener el valor actualizado de lighting_condition
 * @param valor
 */
const getUpdateLighting = (value: string) => {
  updateImages(undefined, value);
};

/**
 * Obtener el valor actualizado de label
 * @param valor
 */
const getLabel = (value: string) => {
  updateImages(value, undefined);
};

/**
 * Actualizar valores
 * @param label
 * @param lighting
 */
const updateImages = (label: string | undefined, lighting: string | undefined) => {
  selectedImages.value.forEach((id) => {
    const selectedImageIndex = allImages.value?.findIndex((_) => _.id == id);
    if (!allImages.value[selectedImageIndex].imageLabel) {
      allImages.value[selectedImageIndex].imageLabel = {} as ImageLabel;
      allImages.value[selectedImageIndex].imageLabel.image = {
        id: allImages.value[selectedImageIndex].id,
      };
    }

    if (lighting) {
      allImages.value[selectedImageIndex].imageLabel.lighting_condition = lighting;
    }
    if (label) {
      allImages.value[selectedImageIndex].imageLabel.label = label;
    }

    if (
      allImages.value[selectedImageIndex].imageLabel.lighting_condition &&
      allImages.value[selectedImageIndex].imageLabel.label
    ) {
      allImages.value[selectedImageIndex].imageLabel.statusLabel = "success";
    }

    const indexImageLabel = labelArray.value?.findIndex((_) => _.image.id == id);
    if (indexImageLabel != undefined && indexImageLabel >= 0) {
      labelArray.value[indexImageLabel].label =
        allImages.value[selectedImageIndex].imageLabel.label;
      labelArray.value[indexImageLabel].lighting_condition =
        allImages.value[selectedImageIndex].imageLabel.lighting_condition;
      labelArray.value[indexImageLabel].statusLabel =
        allImages.value[selectedImageIndex].imageLabel.statusLabel;
    } else {
      const imageLabel = {} as ImageLabel;
      imageLabel.label = allImages.value[selectedImageIndex].imageLabel.label;
      imageLabel.lighting_condition =
        allImages.value[selectedImageIndex].imageLabel.lighting_condition;
      imageLabel.image = { id: allImages.value[selectedImageIndex].id };
      imageLabel.statusLabel = allImages.value[selectedImageIndex].imageLabel.statusLabel;
      labelArray.value.push(imageLabel);
    }
  });

  emit("updateImages", allImages.value, src.value, copyAllImages.value, labelArray.value);
};

const handleKey = (e: Event) => {
  if (e.key === "ArrowDown") {
    console.log("Bajar");
  }
};

const openImage = (img: ImageLabelData) => {
  selectedImage.value = img;
  isOpenImage.value = true;
};

onBeforeMount(async () => {
  window.addEventListener("keydown", handleKey);
  const stationId = props.filters.samplingPoint?.station?.id || 0;
  cameraConfigs.value = await getCamerasConfigurationByStationId(stationId);

  uploadMore(LIMIT);
  updateCurrentImage();
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleKey);
});

expose({
  labelArray,
  allImages,
  src,
  copyAllImages,
  currentImage,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_div = _resolveComponent("el-div")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { gutter: 8 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 17 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_div, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_row, {
                  class: "imagenes-container first",
                  "infinite-scroll-disabled": loading.value,
                  "infinite-scroll-distance": 50
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allImages.value, (img, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["imagen-card", {
              'has-samples': correctRoute && img.hasSamples,
              'no-samples': correctRoute && !img.hasSamples,
            }])
                      }, [
                        _createVNode(_component_el_row, {
                          type: "flex",
                          align: "middle",
                          class: "container-tags"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, {
                              type: 
                  img.imageLabel && img.imageLabel.statusLabel ? img.imageLabel.statusLabel : 'info'
                ,
                              onClick: ($event: any) => (openImage(img))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(img?.dateTime
                    ? _ctx.$d(new Date(img?.dateTime?.toLocaleString()), "dateTimeNoSecs").replace(
                        ",",
                        ""
                      )
                    : "-"), 1)
                              ]),
                              _: 2
                            }, 1032, ["type", "onClick"]),
                            _createVNode(_component_el_tag, {
                              type: "info",
                              class: "tag-truncate tipologia-tag"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(img?.nameTmoa ? img.nameTmoa.slice(0, -3) : img?.camera || "-"), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (src.value[img?.fileName])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: src.value[img?.fileName],
                              alt: img?.filename,
                              class: _normalizeClass(["imagen", { selected: selectedImages.value.has(img.id) }]),
                              onClick: ($event: any) => (toggleSelection(img, index, $event))
                            }, null, 10, _hoisted_1))
                          : (_openBlock(), _createElementBlock("img", _hoisted_2))
                      ], 2))
                    }), 128)),
                    _createVNode(_component_el_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (uploadMore())),
                      disabled: finished.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ArrowDown))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["infinite-scroll-disabled"])), [
                  [_directive_infinite_scroll, uploadMore]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 7 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ImageLabelForm), {
              onUpdateLighting: getUpdateLighting,
              onUpdateLabel: getLabel,
              image: copyCurrentImage.value,
              updatedLabel: currentImage.value,
              formFilter: __props.filters,
              images: allImages.value,
              labels: labelArray.value
            }, null, 8, ["image", "updatedLabel", "formFilter", "images", "labels"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: isOpenImage.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isOpenImage).value = $event)),
      width: "80%"
    }, {
      default: _withCtx(() => [
        (isOpenImage.value)
          ? (_openBlock(), _createBlock(_unref(ImagesLabelGallery), {
              ref_key: "formCmp",
              ref: formCmp,
              filters: props.filters,
              images: allImages.value,
              imagesrc: src.value,
              copy: copyAllImages.value,
              labels: props.labels,
              filterImages: props.filterImages,
              key: 'picture-' + galleryKey.value,
              notEdit: isOpenImage.value,
              currentImage: selectedImage.value
            }, null, 8, ["filters", "images", "imagesrc", "copy", "labels", "filterImages", "notEdit", "currentImage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})